import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { SearchParams, SearchResponse } from './search.types'

const search = async (params: SearchParams): Promise<SearchResponse> => {
  const response = await apiClient.get<SearchResponse>('/v1/platform/search', {
    params: {
      Key: params.key,
      IncludeVaults: params.includeVaults,
      IncludeDocuments: params.includeDocuments,
      IncludeEnvelopes: params.includeEnvelopes,
      IncludeTemplates: params.includeTemplates,
      IncludeContacts: params.includeContacts,
      IncludeSigners: params.includeSigners,
      IncludeUserAccounts: params.includeUserAccounts,
    },
  })
  return response.data
}

export const useSearch = (params: SearchParams | null) => {
  return useQuery({
    queryKey: ['search', params],
    queryFn: () => search(params!),
    enabled: !!params && params.key.length >= 2,
  })
}
